<template>
	<div class="favorites-box">
		<div class="title">My Books</div>
		<ul>
			<li>
				<router-link to="/editBookBase">
					<div class="crear-box">
						<i class="el-icon-reading"></i>
						<div class="crear-box-text"><em>CREAR HISTORIA</em></div>
					</div>
				</router-link>
			</li>
			<li v-for="(item,index) in books" :key="index" @click="goBookDetail(item)">
				<div class="demo-image">
					<el-image style="width: 100px; height: 130px" :src="item.cover_image === null?defaultImg:item.cover_image"></el-image>
				</div>
				<span>{{item.title}}</span>
				<i class="el-icon-close" @click.stop="delbookFn(item.id)"></i>
			</li>
		</ul>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		name: "Favorites",
		data() {
			return {
				defaultImg: require('../../assets/bg_default.png')
			}
		},
		computed: mapState({
			books: state => state.home.books,
		}),
		methods: {
			goBookDetail(book) {
				this.$router.push({
					name: 'BookItem',
					query: {
						book_id: book.id
					} 
				});	
			},
			delbookFn(book_id) {
				this.$store.dispatch('home/openModalFn',book_id)
			}
		}
	}
</script>

